/**
 * Service for handling localStorage operations
 * 
 * This service replaces the cookie service for storing user data.
 * The JWT token is still stored in an HttpOnly cookie managed by the server.
 */

// Set an item in localStorage with the given name and value
export const setItem = (name, value) => {
  try {
    localStorage.setItem(name, typeof value === 'object' ? JSON.stringify(value) : value);
    return true;
  } catch (error) {
    console.error('Error setting localStorage item:', error);
    return false;
  }
};

// Get an item from localStorage by name
export const getItem = (name, parseJson = false) => {
  try {
    const value = localStorage.getItem(name);
    if (value === null) return null;
    return parseJson ? JSON.parse(value) : value;
  } catch (error) {
    console.error('Error getting localStorage item:', error);
    return null;
  }
};

// Remove an item from localStorage by name
export const removeItem = (name) => {
  try {
    localStorage.removeItem(name);
    return true;
  } catch (error) {
    console.error('Error removing localStorage item:', error);
    return false;
  }
};

// Check if user is authenticated by checking for user data in localStorage
export const isAuthenticated = () => {
  const userData = getItem('user_data', true);
  return !!(userData && userData.email);
};

export default {
  setItem,
  getItem,
  removeItem,
  isAuthenticated
};
